import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import { apiPost, apiPatch } from '~/util/api'
import { useMutation } from '@tanstack/react-query'

export const useCoachResourceForm = ({
  showCreateResourceForm,
  onResourceCreated,
  setIsOpen,
}) => {
  const schema = {
    name: z.string().min(1, { message: 'Name is required' }),
    description: z.string().min(1, { message: 'Description is required' }),
    length: z.number().min(1, { message: 'Time is required' }),
    url: z.string().min(1, { message: 'URL is required' }),
  }

  const defaultValues = {
    name: '',
    description: '',
    length: 0,
    url: '',
  }

  const form = useForm({
    resolver: zodResolver(z.object(schema)),
    defaultValues,
  })

  const candidateId =
    typeof window !== 'undefined'
      ? window.location.pathname.split('/').pop()
      : ''

  const createResourceMutation = useMutation({
    mutationFn: async (values) => {
      return apiPost(
        `/coach/candidates/${candidateId}/trackers/create_new_coach_action_plan_resource.json`,
        { resource: values },
      )
    },
  })

  const addToActionPlanMutation = useMutation({
    mutationFn: async (slug) => {
      return apiPatch(
        `/coach/candidates/${candidateId}/trackers/add_item.json?slug=${slug}`,
      )
    },
  })

  const onSubmit = (values, addToActionPlan = false) => {
    createResourceMutation.mutate(values, {
      onSuccess: (response) => {
        if (response?.status === 200) {
          if (addToActionPlan && response.data?.slug) {
            addToActionPlanMutation.mutate(response.data.slug, {
              onError: (error) => {
                console.error('Error adding to action plan:', error)
              },
            })
          }
          if (addToActionPlan) {
            setIsOpen(false)
          }
          showCreateResourceForm(false)
          if (typeof onResourceCreated === 'function') {
            onResourceCreated()
          }
          return response.data
        } else {
          console.error('Unexpected response:', response)
        }
      },
      onError: (error) => {
        console.error('Error creating resource:', error)
      },
    })
  }

  return { form, onSubmit, createResourceMutation, addToActionPlanMutation }
}
